import { render, staticRenderFns } from "./comp13.vue?vue&type=template&id=639fede0&scoped=true"
import script from "./comp13.vue?vue&type=script&lang=ts"
export * from "./comp13.vue?vue&type=script&lang=ts"
import style0 from "./comp13.vue?vue&type=style&index=0&id=639fede0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639fede0",
  null
  
)

export default component.exports